import { AfterContentInit, Directive, OnDestroy, TemplateRef } from '@angular/core';
import { SgSidenavService } from './sidenav.service';

@Directive({
  selector: '[sgSidenav]',
  standalone: false,
})
export class SgSidenavDirective implements AfterContentInit, OnDestroy {
  constructor(
    public templateRef: TemplateRef<any>,
    private sidenavService: SgSidenavService
  ) {}

  ngAfterContentInit(): void {
    this.sidenavService.injectComponent(this.templateRef);
  }

  ngOnDestroy(): void {
    this.sidenavService.removeComponent();
  }
}
